export const normalizeApprovalStatus = (status) =>
  String(status || "")
    .toLowerCase()
    .trim();

export const getApprovalStatusKind = (status) => {
  const value = normalizeApprovalStatus(status);
  if (value === "approved" || value === "согласован") return "approved";
  if (
    value === "rejected" ||
    value === "отклонен" ||
    value === "отклонён" ||
    value === "не согласован"
  ) {
    return "rejected";
  }
  if (value.includes("отменен")) return "cancelled";
  return "pending";
};

export const isPendingEstimateApproval = (approval, userId) => {
  if (!approval) return false;

  const overallKind = getApprovalStatusKind(approval.status);
  if (overallKind !== "pending") return false;

  const steps = Array.isArray(approval.steps) ? approval.steps : [];
  if (userId == null || steps.length === 0) {
    return true;
  }

  const myStep = steps.find(
    (step) =>
      step?.approver_id != null && String(step.approver_id) === String(userId),
  );
  if (!myStep) return true;

  return getApprovalStatusKind(myStep.status) === "pending";
};

export const countPendingEstimateApprovals = (approvals, userId) =>
  (Array.isArray(approvals) ? approvals : []).filter((approval) =>
    isPendingEstimateApproval(approval, userId),
  ).length;

export const findActiveApproval = (approvals) =>
  (Array.isArray(approvals) ? approvals : []).find((approval) => {
    const overallKind = getApprovalStatusKind(approval?.status);
    if (
      overallKind === "approved" ||
      overallKind === "rejected" ||
      overallKind === "cancelled"
    ) {
      return false;
    }
    const steps = Array.isArray(approval?.steps) ? approval.steps : [];
    if (steps.length === 0) return true;
    return steps.some(
      (step) => getApprovalStatusKind(step.status) === "pending",
    );
  }) || null;

export const formatCorrectionApprovalAmount = (value) => {
  if (value === null || value === undefined || value === "") return "—";
  const n = Number(value);
  if (!Number.isFinite(n)) return "—";
  return `₸ ${Math.round(n).toLocaleString("ru-RU")}`;
};
